<template>
  <div>
      <!-- <b-card :title="$t('privacy_form_handling_sub_title')">-->
        <b-row>
          <b-col md="6">
            <b-form-group
              :label="$t('privacy_form_protocol')"
              label-for="protocol">
              <b-form-input
                id="protocol"
                :value="_.get(requestForm, 'protocol_number')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col md="3" class="print:hidden content-center">
            <ProtocolQueryHistoryPopup :protocol_number="_.get(requestForm, 'protocol_number')" type="lgpd" />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('privacy_form_request')"
              label-for="request">
              <v-select
                readonly
                :searchable="false"
                :clearable="false"
                multiple
                dir="ltr"
                :value="_.get(requestForm, 'request_form_lgpd.categories')"
                noDrop
                :options="requestCategoryList"
                label="name">
                <template
                  v-slot:selected-option-container="{ option}">
                  <div
                    class="vs__selected "
                    v-b-tooltip.hover
                    :title="option.description">{{ option.name }}
                  </div>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4" v-if="_.get(requestForm, 'request_form_lgpd.legal_entity.id')">
            <b-form-group
              :label="$t('privacy_form_legal_document')"
              label-for="unity">
              <b-form-input
                id="unity"
                :value="_.get(requestForm, 'request_form_lgpd.legal_entity.cnpj_formmated')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col md="8">
            <b-form-group
              :label="$t('privacy_form_unity')"
              label-for="unity">
              <b-form-input
                id="unity"
                :value="_.get(requestForm, 'request_form_lgpd.legal_entity.name') ? _.get(requestForm, 'request_form_lgpd.legal_entity.name') : 'Outras'"
                readonly/>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group
              :label="$t('privacy_form_requester')"
              label-for="requester">
              <b-form-input
                id="requester"
                :value="_.get(requestForm, 'request_form_lgpd.request_type_str')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t('privacy_form_bond_type')"
              label-for="bond_type">
              <b-form-input
                id="bond_type"
                :value="_.get(requestForm, 'request_form_lgpd.request_bond_type.name')"
                readonly/>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="7">
            <b-form-group
              :label="$t('privacy_form_name')"
              label-for="name">
              <b-form-input
                id="name"
                :value="_.get(requestForm, 'request_form_lgpd.name')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col md="2" v-if="_.get(requestForm, 'request_form_lgpd.request_type') != 'AN'">
            <b-form-group
              :label="$t('privacy_form_birth_date')"
              label-for="birth_date">
              <b-form-input
                id="birth_date"
                :value="_.get(requestForm, 'request_form_lgpd.birth_date_formatted')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              :label="_.get(requestForm, 'request_form_lgpd.request_type') == 'AN' ? $t('privacy_form_legal_document'): $t('privacy_form_document') "
              label-for="document">
              <b-form-input
                id="document"
                :value="_.get(requestForm, 'request_form_lgpd.document_number_formmatted')"
                readonly/>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <b-form-group
              :label="$t('privacy_form_email')"
              label-for="email">
              <b-form-input
                id="email"
                :value="_.get(requestForm, 'request_form_lgpd.email')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t('privacy_form_phone')"
              label-for="phone">
              <b-form-input
                id="phone"
                :value="_.get(requestForm, 'request_form_lgpd.phone')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              :label="$t('privacy_form_country')"
              label-for="country">
              <b-form-input
                id="country"
                :value="_.get(requestForm, 'request_form_lgpd.country.name')"
                readonly/>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <!-- description -->
            <b-form-group
              :label="$t('privacy_form_description')"
              label-for="description"></b-form-group>
              <b-form-textarea
                id="description"
                :value="_.get(requestForm, 'request_form_lgpd.description')"
                rows="4"
                readonly/>
          </b-col>
        </b-row>
        <b-row class="pt-2">
          <b-col md="12">
            <media-list :medias="files" :show-delete="false" :action-on-click="true"/>
          </b-col>
        </b-row>
        <b-row class="m-0">
          <b-col
            lg="12">
            <h5 class="mt-2 mb-0">{{$t('privacy_form_handling')}}</h5>
            <vs-divider></vs-divider>
          </b-col>
        </b-row>
        <b-row class="m-0">
          <b-col
            lg="4">
              <b-form-group
              :label="$t('privacy_form_status')"
              label-for="status">
              <b-form-input
                id="status"
                :value="_.get(requestForm, 'request_form_handling.status_str')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col lg="8" class="print:hidden content-center">
              <HandlingHistoryPopup :id="id" :serviceDelegate="services.privacyFormHandlingService" />
          </b-col>
        </b-row>
  </div>
</template>

<script>
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import MediaList from '@/components/media/MediaList.vue'
import {
  BContainer,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormTextarea,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip
} from 'bootstrap-vue'

//Services
import RequestCategoryFormService from '@/services/api/RequestCategoryFormService'
import PrivacyFormHandlingService from '@/services/api/PrivacyFormHandlingService'

import ProtocolQueryHistoryPopup from '@/components/popup/ProtocolQueryHistoryPopup'
import HandlingHistoryPopup from '@/components/popup/HandlingHistoryPopup'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    Datepicker,
    vSelect,
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormInput,
    BFormTextarea,
    BTable,
    MediaList,
    ProtocolQueryHistoryPopup,
    HandlingHistoryPopup,
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    requestForm: {
      type: Object,
      default: null
    },
  },
  data: () => ({
    id: null,
    requestForm : null,
    textTreatment: '',
    status: '',
    files: [],
    requestCategoryList: [],
    services: {
      privacyFormHandlingService: null,
      requestCategoryFormService: null
    },
  }),
  methods: {
    getData(id) {
      this.$vs.loading()
      this.services.privacyFormHandlingService.read(id).then(
        data => {
          this.requestForm = data;
          this.status = this.requestForm.request_form_handling.status;
          this.files = _.get(data, 'request_form_lgpd.files', [])
          this.$vs.loading.close()
          this.updateParentFormLgpd();
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(() => this.$vs.loading.close())
    },
    updateParentFormLgpd() {
      this.$emit('setFormLgpd', this.requestForm)
    }
  },
  watch: {

  },
  computed: {

  },
  mounted() {
    if (this.id) {
      this.getData(this.id)
    }
    this.services.requestCategoryFormService.all().then(
      data => {
        this.requestCategoryList = data
      },
      error => {
        this.$vs.loading.close()
      }
    )
  },
  beforeMount() {

    this.services.requestCategoryFormService = RequestCategoryFormService.build(this.$vs)
    this.services.privacyFormHandlingService = PrivacyFormHandlingService.build(this.$vs)
  }
}
</script>
